import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  asset,
  vendor,
  customer,
  workOrderCategory,
  assetCategory,
  user,
  team,
} from "../../api";
import { toast } from "react-toastify";
import { AssetComponent } from "./AssetComponent";
import {
  dateFormat,
  getEmptyField,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";
import { CustomField } from "../../components/CustomField";
import MultipleFilesAttachments from "../../components/MultipleFilesAttachments";
import { LocationFilter } from "../../components/LocationFilter";



const criticalityLevelType = [
  {
    name: "Low",
    id: "low",
  },
  {
    name: "Medium",
    id: "medium",
  },
  {
    name: "High",
    id: "high",
  },
];


function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}
function AddMachine({ afterSubmitCallback,preFilledData }) {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const transfer = searchParams.get("transfer");
  const editMode = !!id && !afterSubmitCallback;
  const { locations, addSetupDone } = useDashboardContext();
  const [sublocations, setSublocations] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [vendorList, setVendor] = useState([]);
  const [assetComponents, setAssetComponents] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [deletedDocument, setDeletedDocument] = useState([]);
  const [profilePicture, setProfilePicture] = useState(null);
  const [selectedFile, setSelectedFile] = useState("");
  const [docName, setDocName] = useState(null);
  const [machineClasses, setMachineClasses] = useState([]);
  const [areas, setAreas] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [sensors, setSensors] = useState([""]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [preview, setPreview] = useState();
  const [machineSpec, setMachineSpec] = useState("");
  const [productManual, setProductManual] = useState("");
  const [otherDoc, setOtherDoc] = useState("");
  const [machineElements, setMachineElements] = useState([]);
  const [deletedElements, setDeletedElements] = useState([]);
  const [deletedDeployments, setDeletedDeployments] = useState([]);
  const [deletedSchedules, setDeletedSchedules] = useState([]);
  const [deletedAttachments, setDeletedAttachments] = useState([]);
  const [locationValue, setLocationValue] = useState([]);
  const { getLocationName } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [emptyField, setEmptyField] = useState([]);
  const [assignType, setAssignType] = useState("individual");
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedLocationPrev, setSelectedLocationPrev] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [dataToSend, setDataToSend] = useState({
    location_id: "",
    asset_name: preFilledData?.asset_name || "",
    asset_model: preFilledData?.asset_model || "",
    criticaly_level: "low",
    serial_number: preFilledData?.serial_number || "",
    customer_id: "",
    team_id: "",
    user_id: "",
    vendor_id: "",
    barcode: "GR-123456",
    description: "",
    category_id: "",
    custom_field: [],
  });
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }
  const handleClose = () => setOpen(false);
  const handleClosePDF = () => setOpenPDF(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    bgcolor: "background.paper",
    border: "2px solid #000",
    divShadow: 24,
    p: "20px",
  };
  const handleFilesChange = (files) => {
    // Update chosen files
    setFilesToUpload([...files]);
  };

  async function getMasterData() {
    try {
      setIsLoading(true);

      const getVendor = vendor.list({});

      const getCustomer = customer.list({});
      const getTeam = team.list({});

      const getUser = user.list({});

      const getCategory = assetCategory.list({});

      const [res, resCust, resTeam, resUser, resCategory] = await Promise.all([
        getVendor,
        getCustomer,
        getTeam,
        getUser,
        getCategory,
      ]);

      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.vendor_name;
            d["value"] = d.id;
          });
          setVendor(data);
        }
      }
      if (resCust.ok) {
        const body = await resCust.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.customer_name;
            d["value"] = d.id;
          });
          setCustomers(data);
        }
      }

      if (resTeam.ok) {
        const body = await resTeam.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.team_name;
            d["value"] = d.id;
          });
          setTeams(data);
        }
      }

      if (resUser.ok) {
        const body = await resUser.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.firstname + " " + d.lastname;
            d["value"] = d.username;
          });
          setUsers(data);
        }
      }

      if (resCategory.ok) {
        const body = await resCategory.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.name;
            d["value"] = d.id;
          });
          setCategories(data);
        }
      }

      setSublocations([locations]);
      if (editMode) {
        await getRecord();
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (locations.length) getMasterData();
  }, [locations]);

  async function getRecord() {
    const res = await asset.getOne(id);

    if (res.ok) {
      const body = await res.json();
      let data = body.data;

      const defaultValue = {
        location_id: data.location_id,
        asset_name: data.asset_name,
        asset_model: data.asset_model,
        serial_number: data.serial_number,
        customer_id: data.customer_id,
        team_id: data.team_id,
        user_id: data.user_id,
        vendor_id: data.vendor_id,
        barcode: data.barcode,
        description: data.description,
        category_id: data.category_id,
        custom_field: data.custom_field || [],
        criticaly_level: data.criticaly_level,
      };

      if (data.location) {
        //find parent
        const locationSeq = [];
        setupLocationValues(locationSeq, data.location);
        locationSeq.reverse();
        setLocationValue(locationSeq);
        setSelectedLocation(data.location);
        setSelectedLocationPrev(locationSeq);
      }

      if (data.asset_image) {
        if (
          data.asset_image.includes("http") ||
          data.asset_image.includes("https")
        ) {
          setPreview(data.asset_image);
        } else {
          setPreview(renderImage(`/machine/attachment/${data.asset_image}`));
        }
      }
      if (data.team_id) {
        setAssignType("team");
      } else if (data.user_id) {
        setAssignType("individual");
      } else if (data.customer_id) {
        setAssignType("customer");
      } else {
        setAssignType("");
      }
      if (data.asset_components) {
        const assetComponents = data.asset_components.map((ac) => {
          return {
            id: ac.id,
            component: ac.component,
            description: ac.description,
          };
        });
        setAssetComponents(assetComponents);
      }
      const att = [];
      if (data.attachments) {
        Object.keys(data.attachments).forEach((key) => {
          if (data.attachments[key]) {
            const name = key.split("_")[3];
            const type = key.split("_")[2];
            const isRequest = key.split("_")[0] !== "workoder";
            const url = renderImage(
              `machine/attachment/${data.attachments[key]}`
            );
            const attachment = {
              name: name,
              origin_key: key,
              exist: true,
              type,
              url,
              value: data.attachments[key],
            };
            att.push(attachment);
          }
        });
        setAttachments(att);
      }

      setDataToSend(defaultValue);
    }
  }

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);

  const handleLocationChange = (e, index) => {
    const location_values = [...locationValue];
    console.log({location_values, index, value:e.target.value})
    location_values.splice(index);
    location_values.push(e.target.value);
    console.log({location_values, index})
    setLocationValue(location_values);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {

      let payload = { ...dataToSend };
      payload.custom_field = JSON.stringify(payload.custom_field);
      payload["assignType"] = assignType;
      payload["asset_components"] = JSON.stringify(assetComponents);

      const mandatory = [
        "asset_name",
        "asset_model",
        "category_id",
        "barcode",
        "serial_number",
        "criticaly_level",
        "description",
        "location_id",
      ];

      if (assignType == "individual") mandatory.push("user_id");
      if (assignType == "team") mandatory.push("team_id");
      if (assignType == "customer") mandatory.push("customer_id");
      console.log({payload, mandatory})
      const ef = getEmptyField(payload, mandatory);

      setEmptyField(ef);
      console.log({ payload, ef });
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }
      let res;
      if (!editMode) {
        res = await asset.create(payload, selectedFile, attachments);
        await addSetupDone({ user_setup_center: "asset" });
      } else {
        res = await asset.update(id, payload, selectedFile, attachments);
      }

      if (res.ok) {
        toast.success("Successfully Saved");
        const body = await res.json();

        if (!editMode) {
          if (afterSubmitCallback) {
            afterSubmitCallback({
              type: "submit",
              data: body.data,
            });
          } else {
            backToList();
          }
        }
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const generateRandomQR = () => {
    //random number 16 character with prefix GR-
    //example GR-123456919191929
    // random number only wihtout string
    // example 123456919191929
    const random = Math.floor(Math.random() * 10000000000000000);
    setDataToSend((prevData) => ({
      ...prevData,
      ["barcode"]: `GR-${random}`,
    }));
  };

  const onSelectFile = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };

  useEffect(() => {
    generateRandomQR();
  }, []);

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    //console.log({ selectedFile });
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    //console.log({ objectUrl });
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const handleAddNewCategory = async () => {
    if (!newCategory) return;
    const result = await assetCategory.create({
      name: newCategory,
    });

    if (result.ok) {
      const body = await result.json();
      const data = body.data;
      setCategories((prev) => [{ ...data }, ...prev]);
      setNewCategory("");
    }
  };

  return (
    <Card>
      <LoadingIndicator open={isLoading} />

      {transfer && <CardHeader>Transfer Asset</CardHeader>}
      {!transfer && (
        <CardHeader>{editMode && "Edit "}Asset Information</CardHeader>
      )}

      <CardBody>
        <div className="row">
          <div className="col-12 col-md-9">
            <div>

            <LocationFilter
          type="input"
          onChange={(location) => {
            handleOnchange({
              target: {
                name: "location_id",
                value: location.id,
              },
            });
          }}
              defaultValue={selectedLocation}
              defaultOptionsValue={selectedLocationPrev}
              emptyField={emptyField}
        />

              {!transfer && (
                <>
                  <NormalInput
                    required={true}
                    value={dataToSend["asset_name"]}
                    label="Asset Name"
                    onchange={handleOnchange}
                    name="asset_name"
                    emptyField={emptyField}
                  />
                  <NormalInput
                    required={true}
                    value={dataToSend["asset_model"]}
                    label="Asset Model"
                    onchange={handleOnchange}
                    name="asset_model"
                    emptyField={emptyField}
                  />

                  <NormalInput
                    required={true}
                    value={dataToSend["serial_number"]}
                    label="Serial Number"
                    onchange={handleOnchange}
                    name="serial_number"
                    emptyField={emptyField}
                  />

<NormalSelect
              label={"Criticality Level"}
              onchange={handleOnchange}
              value={dataToSend["criticaly_level"]}
              name={"criticaly_level"}
              id="criticaly_level"
              className="form-select"
              valueKey={"id"}
              list={criticalityLevelType}
              emptyField={emptyField}
              required
            />

                  <NormalSelect
                    required={true}
                    value={dataToSend["category_id"]}
                    label="Category"
                    onchange={handleOnchange}
                    list={categories}
                    name="category_id"
                    valueKey={"id"}
                    onSubmit={handleAddNewCategory}
                    emptyField={emptyField}
                    addMoreComponent={
                      <NormalInput
                        required={true}
                        value={newCategory}
                        label="Category"
                        onchange={(e) => {
                          setNewCategory(e.target.value);
                        }}
                      />
                    }
                  />
                  <div className={"row"}>
                    <div className="col-sm-5">
                      <div className="form-group mb-3">
                        <label
                          className="form-label"
                          htmlFor="exampleFormControlInput1"
                        >
                          QR Code
                        </label>
                        <div style={{ position: "relative", display: "block" }}>
                          <QRCode
                            value={dataToSend["barcode"]}
                            logoImage={"/cmms/logo.png"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-7">
                      <NormalInput
                        required={true}
                        value={dataToSend["barcode"]}
                        label="Custom Value"
                        onchange={handleOnchange}
                        name="barcode"
                        emptyField={emptyField}
                      />
                      <button
                        className="btn btn-outline-theme btn-lg"
                        onClick={generateRandomQR}
                      >
                        Generate Random QR
                      </button>
                    </div>
                  </div>

                  <NormalTextArea
                    required={true}
                    value={dataToSend["description"]}
                    label="Description"
                    onchange={handleOnchange}
                    name="description"
                    emptyField={emptyField}
                  />
                </>
              )}

              {(transfer || !editMode) && (
                <Card style={{ marginTop: "10px", marginBottom: "10px" }}>
                  <CardHeader>Ownership</CardHeader>

                  <CardBody>
                    <NormalSelect
                      label={"Assignee"}
                      className="form-select"
                      onchange={(e) => {
                        setAssignType(e.target.value);
                      }}
                      value={assignType}
                      list={[
                        {
                          name: "Individual",
                          value: "individual",
                        },
                        {
                          name: "Team",
                          value: "team",
                        },
                        {
                          name: "Customer",
                          value: "customer",
                        },
                      ]}
                      valueKey={"value"}
                    />

                    {assignType === "individual" && (
                      <NormalSelect
                        label={"Assigned to"}
                        id="assignee"
                        className="form-select"
                        onchange={handleOnchange}
                        value={dataToSend["user_id"]}
                        name={"user_id"}
                        emptyField={emptyField}
                        list={users}
                        valueKey={"value"}
                      />
                    )}
                    {assignType === "team" && (
                      <NormalSelect
                        label={"Assigned to"}
                        id="assignee"
                        className="form-select"
                        onchange={handleOnchange}
                        value={dataToSend["team_id"]}
                        name={"team_id"}
                        required
                        emptyField={emptyField}
                        valueKey={"value"}
                        list={teams}
                      />
                    )}

                    {assignType === "customer" && (
                      <NormalSelect
                        label={"Assigned to"}
                        id="assignee"
                        className="form-select"
                        onchange={handleOnchange}
                        value={dataToSend["customer_id"]}
                        name={"customer_id"}
                        required
                        emptyField={emptyField}
                        valueKey={"value"}
                        list={customers}
                      />
                    )}
                  </CardBody>
                </Card>
              )}
            </div>
            {!transfer && (
              <Card style={{ marginTop: "10px" }}>
                <CardHeader>Attachments</CardHeader>
                <CardBody>
                  <MultipleFilesAttachments
                    attachments={attachments}
                    setAttachments={setAttachments}
                  ></MultipleFilesAttachments>
                </CardBody>
              </Card>
            )}
            {!transfer && (
              <>
                <AssetComponent
                  readOnly={false}
                  value={assetComponents}
                  setValue={setAssetComponents}
                ></AssetComponent>
                <div>
                  <CustomField
                    value={dataToSend["custom_field"]}
                    onChange={(value) =>
                      handleOnchange({
                        target: {
                          name: "custom_field",
                          value: value,
                        },
                      })
                    }
                  />
                </div>

                <div>
                  <Card style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <CardHeader>CGM Integration</CardHeader>
                    <CardBody>
                      <small>
                        We can Integrate the Machine as the Asset that later we
                        can create work order for it
                      </small>
                      <NormalSelect
                        value={dataToSend["vendor_id"]}
                        label="Machine"
                        onchange={handleOnchange}
                        list={[]}
                        valueKey="id"
                        name="vendor_id"
                      />
                    </CardBody>
                  </Card>
                </div>
                <Card>
                  <CardHeader>More Information</CardHeader>
                  <CardBody>
                    <NormalSelect
                      value={dataToSend["vendor_id"]}
                      label="Vendor"
                      onchange={handleOnchange}
                      list={vendorList}
                      valueKey="id"
                      name="vendor_id"
                    />
                  </CardBody>
                </Card>
              </>
            )}
          </div>
          <div className="col-12 col-md-3">
            {!transfer && (
              <Card>
                <CardBody>
                  <label htmlFor="files2">
                    {preview ? (
                      <>
                        <img src={preview} className="img-thumbnail" alt="" />
                        <div
                          style={{
                            textAlign: "center",
                            cursor: "pointer",
                            marginTop: "5px",
                          }}
                        >
                          Change Photo <i className="fa fa-camera"></i>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            minHeight: "150px",
                            alignItems: "center",
                            transform: "translate(-50%, -50%)",
                          }}
                        >
                          <i className="fa fa-camera"></i>
                          <div>Add a Photo</div>
                        </div>
                      </>
                    )}
                  </label>
                  <input
                    id="files2"
                    onChange={onSelectFile}
                    style={{ visibility: "hidden", position: "absolute" }}
                    type="file"
                    accept="image/png, image/jpeg"
                  />
                </CardBody>
              </Card>
            )}
          </div>
        </div>

        <div className="mt-4 flex">
          <button
            className="btn btn-outline-theme btn-lg me-2"
            onClick={handleSubmit}
          >
            {editMode ? "SAVE" : "ADD"}
          </button>
          <button
            className="btn btn-outline-danger btn-lg"
            onClick={
              afterSubmitCallback
                ? () => {
                    afterSubmitCallback({ type: "cancel" });
                  }
                : backToList
            }
          >
            CANCEL
          </button>
        </div>
      </CardBody>
    </Card>
  );
}

export default AddMachine;
